<script setup lang="ts">
import { defineProps } from 'vue'
import { useRouter } from '#imports'

const props = defineProps<{
  to?: string | Record<string, any>  // '/data/ubrief/list' 같은 경로 또는 라우트 객체
  moreClass?: string
  replace?: boolean
}>()

const router = useRouter()
const go = () => {
  if (!props.to) return
  props.replace ? router.replace(props.to as any) : router.push(props.to as any)
}
</script>

<template>
  <a-button :class="['common-button', props.moreClass]" @click="go">
    <slot />
  </a-button>
</template>

<style scoped lang="scss">
@use 'button.scss';
</style>